// FILE HAS CODE COMMENTED CODE
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiPlusCircle, FiEdit3, FiEye } from "react-icons/fi";
import { FaRegTrashAlt } from "react-icons/fa";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { RoleService } from "app/_services/RoleService/RoleService";
import TableExport from "app/views/custom/components/Export/TableExport";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { CONSTANT, SITETYPE, USERROLE } from "./Constant";
import LastLog from "app/views/custom/components/Logs/LastLog";
import toastr from "toastr";
import ApproveReject from "app/views/custom/components/ApproveReject/ApproveReject";
import localStorageService from "app/services/localStorageService";
import { Fragment } from "react";

class Roles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      roleData: [],
      projectData: {},
      projectId: this.props.match.params.id ? this.props.match.params.id : null,
      auth_user: localStorageService.getItem("auth_user"),
    };
  }

  componentDidMount() {
    this.setRolesData();
  }

  setRolesData = async () => {
    let response = await RoleService.RoleList();

    if (response && response.status) {
      if (response.data && response.data.roles) {
        this.setState(
          {
            roleData: response.data.roles,
          },
          () => {
            let data = JSON.parse(JSON.stringify(this.state.roleData));
            Array.isArray(data) &&
              data.map((rowData, rowIndex) => {
                rowData["sid"] = rowIndex + 1;
              });
            this.setState({
              roleData: data,
            });
          }
        );
      }
    } else {
      this.setState({
        roleData: [],
      });
    }
  };

  delete(e, id) {
    e.preventDefault();

    confirmAlert({
      title: "Delete Role",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let response = await RoleService.deleteRole(id);

            if (response) {
              if (response.message) {
                toastr.info(response.message || "Deleted Successfully!");
                this.setRolesData();
              } else if (response.message) {
                toastr.info(response.message);
              }
            }
          },
        },
        {
          label: "No",
          onClick: () => console.log("test"),
        },
      ],
    });
  }

  paginationOptions = {
    // custom: true,
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: this.state?.roleData.length,
  };

  render() {
    let { roleData } = this.state;
    let { SearchBar } = Search;
    let sortableColumn = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "title",
        text: "Role",
        sort: true,
      },
      {
        dataField: "roleLable",
        text: "Level",
        sort: true,
        formatter: (rowContent, row, index) => {
          const filterData = USERROLE.filter((d) => d.value == row.roleLable);
          if (filterData.length > 0) return filterData[0].name;
        },
      },
      {
        dataField: "siteType",
        text: "Site Type",
        sort: true,
        formatter: (rowContent, row, index) => {
          const filterData = SITETYPE.filter((d) => d.value == row.siteType);
          if (filterData.length > 0) return filterData[0].name;
        },
      },
      // {
      //   dataField: "permissionNames",
      //   text: "Manage Permission",
      //   sort: true,
      //   formatter: (rowContent, row, index) => {
      //     let data = "";
      //     let text = "";

      //     if (row.permissionNames) {
      //       data = JSON.parse(row.permissionNames);
      //       if (data && Object.keys(data).length > 0) {
      //         let flag = 0;
      //         for (const property in data) {
      //           if (data[property]) {
      //             if (flag === 0) {
      //               text = CONSTANT[property];
      //             } else {
      //               text += ", " + CONSTANT[property];
      //             }
      //             flag++;
      //           }
      //         }
      //       }
      //     }

      //     return <span>{text}</span>;
      //   },
      // },
      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          let flag = false;
          if (
            this.state.auth_user &&
            this.state.auth_user.user &&
            this.state.auth_user.user.role
          ) {
            if (this.state.auth_user.user.role.roleLable) {
              let roleLable = this.state.auth_user.user.role.roleLable;
              if (row && row.roleLable) {
                if (roleLable < row.roleLable) {
                  flag = true;
                }
              }
            }
          }
          // console.log("row", this);
          return (
            <div className="actionIconsGroup">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">View</Tooltip>}
              >
                <Link
                  to={"/user-management/roles/view/" + row.id}
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </OverlayTrigger>
              {flag && (
                <Fragment>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
                  >
                    <Link
                      to={"/user-management/roles/edit/" + row.id}
                      className="icons text-cyanBlue"
                    >
                      <FiEdit3 />
                    </Link>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                  >
                    <span
                      onClick={(e) => this.delete(e, row.id)}
                      className="icons text-danger pointer"
                    >
                      <FaRegTrashAlt />
                    </span>
                  </OverlayTrigger>

                  <ApproveReject
                    rowId={row.id}
                    tableName={"roles"}
                    setData={this.setRolesData}
                    permission=""
                    status={row.status}
                  ></ApproveReject>
                </Fragment>
              )}
            </div>
          );
        },
      },
    ];
    return (
      <div>
        <MainBreadcrumb
          routeSegments={[
            { name: "User Management", path: "#" },
            { name: "Roles", path: "#" },
          ]}
          breadCrumbsText="User_Management_Roles"
        />
        <div className="card p-4 mb-4">
          {/* <ToolkitProvider striped keyField="id" data={roleData} columns={sortableColumn} search>
            {(props) => (
              <>
                <div className="d-flex align-items-center justify-content-between pb-3">
                  <SearchBar {...props.searchProps} className="mb-0" />
                  <div className="btn-toolbar">
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add Role</Tooltip>}>
                      <Link className="icons btn-icon font-20 text-cyanBlue" to="/user-management/roles/add">
                        <FiPlusCircle />
                      </Link>
                    </OverlayTrigger>
                    <TableExport tableName={"Roles"} dataColumn={sortableColumn} renderData={roleData} searchText={props.searchProps.searchText}></TableExport>
                  </div>
                </div>
                <BootstrapTable {...props.baseProps} bootstrap4 pagination={paginationFactory(this.paginationOptions)} noDataIndication={"Table is empty"} />
              </>
            )}
          </ToolkitProvider> */}

          <SearchBootstrapTable
            searchKey={"roleDesktopSearch"}
            data={roleData}
            columns={sortableColumn}
            tableKey="role"
          />
        </div>
        <LastLog subModulename={"roles"}></LastLog>
      </div>
    );
  }
}

export default Roles;
